import React from "react";
import { navLinks } from "../../mock";
import { Button } from "../ui/button";

export default function MobileMenu({ onClose }) {
  return (
    <div className="lg:hidden bg-white border-t border-gray-100 px-6 py-4">
      <div className="flex flex-col gap-3">
        {navLinks.map((l) => (
          <a
            key={l.href}
            href={l.href}
            onClick={onClose}
            className="text-sm font-medium text-gray-800 py-2 border-b border-gray-100"
          >
            {l.label}
          </a>
        ))}
        <Button asChild className="bg-brand hover:bg-brand-dark text-white rounded-full mt-2">
          <a href="#contact" onClick={onClose}>Get In Touch</a>
        </Button>
      </div>
    </div>
  );
}
